<template>
    <div class="single-question">

        <ion-row>
            <ion-col size="12" class="text-center">
                <h1>Wiedza</h1>
            </ion-col>
        </ion-row>

        <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>

        <transition name="long-fade">
            <div v-if="!loading && (data && data.length)">

                <ion-row>
                    <ion-col size="12" size-sm="10" offset-sm="1" size-md="8" offset-md="2" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2" class="text-center">
                        <h4 class="text-normal">{{title}}</h4>
                    </ion-col>
                </ion-row>

                <div v-if="isAnswer != null || isBlockedForAnotherAnswer != false" class="text-center">
                    <div>
                        <p><strong>Udzieliłeś już odpowiedzi na to pytanie!</strong></p>

                        <template v-if="isCorrectAnswer == 'fail'" >
                            <p class="color-red mb-0"><svg class="voxion icon-sad-face">
                                <use xlink:href="#icon-sad-face"></use></svg> <strong>Odpowiedź jest niepoprawna. </strong>
                            </p>
                            <template v-if="isBlockedForAnotherAnswer == true">
                                <p>Zapoznaj się raz jeszcze z <router-link :to="{ name: 'KnowledgePill' }">pigułkami wiedzy.</router-link><br>
                                    Na koniec miesiąca zadamy pytanie ponownie.</p>
                            </template>
                            <template v-else>
                                <p>Teraz masz jeszcze jedną szansę na odpowiedź!</p>
                            </template>
                        </template>

                        <template v-if="isCorrectAnswer == 'success'">
                            <p class="color-green mb-0"><svg class="voxion icon-cheerful-face">
                                <use xlink:href="#icon-cheerful-face"></use></svg> <strong>Gratulacje! Odpowiedź jest poprawna.</strong>
                            </p>
                        </template>

                        <template v-if="isBlockedForAnotherAnswer == true">
                            <p>Wróć do <router-link :to="{ name: 'KnowledgeQuestions' }">listy pytań.</router-link></p>
                        </template>
                    </div>
                </div>

                <ion-row v-if="type && isAnswer != true && isBlockedForAnotherAnswer != true">

                    <ion-col size="12" size-sm="10" offset-sm="1" size-md="8" offset-md="2" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2" class="text-center">

                        <h5 class="countdown-timer">
                            <svg class="voxion icon-countdown-timer"><use xlink:href="#icon-countdown-timer"></use></svg>
                            pozostało <countdown-timer ref="countdownTimer" :order=timeForAnswear @timerStop="timer = false" @timerEnd="timerEndHandler()" /> na odpowiedź
                        </h5>

                        <!-- question-content -->
                        <div class="question-content" :class="{ disabled : isFormDisabled }">

                            <template v-if="type == 'once-text'">
                                <div class="type-once-text">
                                    <div v-if="image" class="image">
                                        <img :src="image" />
                                    </div>
                                    <ion-radio-group>
                                        <ion-item v-for="(item, index) in replies" :key="index">
                                            <ion-label stacked @click="radioLabelHandler(item)">{{item.content}}</ion-label>
                                            <ion-radio mode="md" slot="start" @ionSelect="answears = [{id: item.id, name: item.content, isChecked:true}]" :checked="item.isChecked" ></ion-radio>
                                        </ion-item>
                                    </ion-radio-group>
                                </div>
                            </template>

                            <template v-if="type == 'once-image'">
                                <div v-if="image" class="image">
                                    <img :src="image" />
                                </div>
                                <div class="type-once-image">
                                    <div class="yes-or-no">
                                        <div v-for="(item, index) in replies" :key="index" class="radio-item">
                                            <input type="radio"
                                                   :id="'answear_'+item.id"
                                                   name="answears"
                                                   :value="[{id: item.id, name: item.content, isChecked:true}]"
                                                   v-model="answears">
                                            <label :for="'answear_'+item.id">{{item.content}}</label>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="type == 'multiple-image'">
                                <div class="type-multiple-image">
                                    <div class="radio-image-group">
                                        <div v-for="(item, index) in replies" :key="index" class="radio-image">
                                            <input type="radio"
                                                   :id="'answear_'+item.id"
                                                   name="answears"
                                                   :value="[{id: item.id, name: item.content, isChecked:true}]"
                                                   v-model="answears">
                                            <label :for="'answear_'+item.id">
                                                <img :src="item.image" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="type == 'multiple-text'">
                                <div class="type-multiple-text">
                                    <ion-list>
                                        <ion-item v-for="(item, index) in answears" :key="index">
                                            <ion-label stacked @click="item.isChecked = !item.isChecked">{{item.content}}</ion-label>
                                            <ion-checkbox
                                              mode="md"
                                              slot="start"
                                              @ionChange="item.isChecked = $event.target.checked || false"
                                              :checked="item.isChecked">
                                            </ion-checkbox>
                                        </ion-item>
                                    </ion-list>
                                </div>
                            </template>

                        </div>

                        <!-- question-info -->
                        <div class="question-info mt-20">

                            <template v-if="timerEnd" >
                                <p class="color-gray mb-0"><svg class="voxion icon-sad-face">
                                    <use xlink:href="#icon-sad-face"></use></svg> <strong>Czas na opdowiedz minął.</strong>
                                </p>
                                <p>Na koniec miesiąca zadamy pytanie ponownie.</p>
                            </template>

                            <template v-if="questionStatus == 'fail'" >
                                <p class="color-red mb-0"><svg class="voxion icon-sad-face">
                                    <use xlink:href="#icon-sad-face"></use></svg> <strong>Odpowiedź jest niepoprawna. </strong>
                                </p>
                                <p>Zapoznaj się raz jeszcze z <router-link :to="{ name: 'KnowledgePill' }">pigułkami wiedzy.</router-link><br>
                                    Na koniec miesiąca zadamy pytanie ponownie.</p>
                            </template>

                            <template v-if="questionStatus == 'success'">
                                <p class="color-green mb-0"><svg class="voxion icon-cheerful-face">
                                    <use xlink:href="#icon-cheerful-face"></use></svg> <strong>Gratulacje! Odpowiedź jest poprawna.</strong>
                                </p>
                                <p>Nowe pytanie pojawi się w przyszłym tygodniu.</p>
                            </template>

                        </div>

                        <!-- btn -->
                        <div class="mt-20 question-action">
                            <button v-if="!questionStatus" class="btn btn-primary btn-auto" :disabled="disabledSetAnswear" @click="setAnswear" style="min-width: 280px;"><span v-if="loadingForm" class="loader white"></span><span v-else>odpowiedz</span></button>
                        </div>

                    </ion-col>

                </ion-row>

                <div v-if="!type" class="mt-20 text-center">Nie zdefiniowano typu pytania!</div>

            </div>
        </transition>

    </div>
</template>

<script>

    import QuestionService from '../../../services/QuestionsServices';
    import CountdownTimer from "../../../components/CountdownTimer";

    export default {
        components: {CountdownTimer},
        name: 'QuestionSingle',
        props: {
            slug : {
                type: [String, Number],
                requred: true
            },
            questionSlug: {
                type: [String, Number],
                requred: true
            }
        },
        data: () =>({
            loading: true,
            loadingForm: false,
            data: null,
            errors: [],
            timer : true,
            timerEnd : false,
            answears : null,
            replay : null,
            formDisabled: false,
            timeout : null,
        }),
        computed:{
//            ...mapGetters(''),
            dataCollection(){
                return this.data && this.data.length ? this.data[0] : null
            },
            questionStatus(){
                return this.replay || this.replay == false ? (this.replay == true ? 'success' : 'fail') : null;
            },
            type(){
                return this.dataCollection.type != '' ? this.dataCollection.type : null ;
            },
            title(){
                return this.dataCollection.title;
            },
            replies(){
                return this.dataCollection.replies;
            },
            image(){
                return this.dataCollection.image;
            },
            disabledSetAnswear(){
                //array
                if(Array.isArray(this.answears) == true) {
                    return !this.answears.some((o) => {
                        return o.isChecked == true;
                    })
                }
                //object
                return !this.answears ? true : false
            },
            isBlockedForAnotherAnswer(){
                return this.isAnswer == null ? false : (this.dataCollection.isBlockedForAnotherAnswer || false);
            },
            isAnswer(){
                return this.dataCollection.isCorrectAnswer;
            },
            isCorrectAnswer(){
                return this.isAnswer != null ? (this.isAnswer == true ? 'success' : 'fail') : null;
            },
            isFormDisabled(){
                return (this.formDisabled == true || this.timerEnd == true) ? true : false
            },
            timeForAnswear(){
                return this.dataCollection.time - 1;
            }
        },
        methods: {

            radioLabelHandler(item){

                this.answears = [{id: item.id, name: item.content, isChecked:true}]
                this.dataCollection.replies.forEach((o)=>{
                    o.isChecked = false;
                    if(item.id == o.id){
                        o.isChecked = true
                    }
                })

            },

            timerEndHandler(){
                this.timerEnd = true;
                if(this.isAnswer == null) return;
                //
                QuestionService.setAnswear(this.slug, {state: 'timeOut'})
                    .then((response) => { /* */})
                    .catch((e) => {
                        this.errors.push(e.toString())
                    })

            },

            setAnswear(){

                this.formDisabled = true;
                this.$refs.countdownTimer.stopTimer();

                let replies = this.answears.map((o)=>{
                    if(o.isChecked == true ) return o.id;
                })

                this.loadingForm = true;

                QuestionService.setAnswear(this.slug, { replies : replies, responseTime: this.$refs.countdownTimer.getResponseTime(), state: 'sendAnswer' })
                    .then( (response) => {
                        this.replay = response.data.data.isCorrect;
                        //
                        this.goToQuestion();
                        this.loadingForm = false;
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                        this.loadingForm = false;
                    })

            },
            getData: function () {

                this.loading = true;
                QuestionService.getQuestion(this.slug)
                    .then( (response) => {
                        this.loading = false;
                        //
                        this.data = response.data.data;
                        this.answears = this.dataCollection.replies.map((o) => {
                            return {
                                id : o.id,
                                content : o.content,
                                isChecked : false
                            };
                        });
                        // FIX scroll to top
                        const element = document.querySelector('#topOfDocument');
                        element.scrollIntoView()
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })

            },
            goToQuestion: function () {
                this.timeout = setTimeout(()=>{
                    this.$router.push({ name: 'KnowledgeQuestions' })
                }, 15000)
            }
        },
        mounted(){
            this.getData();
        },
        beforeDestroy() {
            clearTimeout(this.timeout);
            this.timerEndHandler();
        }
    }
</script>

<style lang="scss" scoped>

    ion-label {
        white-space: normal !important;
        text-overflow: clip;

        margin-top: 0 !important;
        margin-bottom: 0 !important;

        padding-top: 10px;
        padding-bottom: 10px;
    }

</style>
